import { useEffect } from "react";
import { getUserDataByToken, logOut } from "../../../store/auth/authActions";
import { GET_USER_DATA_URL } from "../../../api/apiRoutes";
import { useDispatch, useSelector } from "react-redux";
import useFacility from "../../../../utils/hooks/useFacility";
import { State } from "../../../store";

export default function useMyAccount() {
  const dispatch = useDispatch();
  const facilityIds = useFacility();
  const userDataAlert = useSelector((state: State) => state.alerts.errors);
  const userToken = useSelector((state: State) => state.auth.userToken);

  useEffect(
    () => {
      if (userToken !== undefined && userToken.userName && !userToken.userName.includes("GUEST")) {
        dispatch(getUserDataByToken(GET_USER_DATA_URL(facilityIds)));
      }
    }, //eslint-disable-next-line
    [userToken]
  );
}
